import React from 'react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';
import { toast } from 'sonner';
import { api } from '../../services/api';

export const CounterModal = ({ counterFor, setCounterFor, counterForm, setCounterForm, fetchData, formatCurrency }) => (
  <Dialog open={!!counterFor} onOpenChange={() => setCounterFor(null)}>
    <DialogContent className="bg-[#0A0A0A] border-[#262626] max-w-md" data-testid="counter-modal">
      <DialogHeader><DialogTitle className="font-serif text-white">Counter Offer</DialogTitle></DialogHeader>
      {counterFor && (
        <div className="space-y-4">
          <p className="text-xs text-muted-foreground">Buyer offered {formatCurrency(counterFor.price_per_fraction)} × {counterFor.fractions} on {counterFor.asset_name}.</p>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Counter price per fraction (£)</label>
            <Input type="number" step="0.01" min="0.01" value={counterForm.price} onChange={e => setCounterForm({...counterForm, price: e.target.value})} className="luxury-input mt-1" data-testid="counter-price-input" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Counter fractions</label>
            <Input type="number" min="1" value={counterForm.fractions} onChange={e => setCounterForm({...counterForm, fractions: e.target.value})} className="luxury-input mt-1" />
          </div>
          <div>
            <label className="text-xs uppercase tracking-wider text-muted-foreground">Message (optional)</label>
            <Input value={counterForm.message} onChange={e => setCounterForm({...counterForm, message: e.target.value})} className="luxury-input mt-1" />
          </div>
          <Button data-testid="submit-counter-btn" onClick={async () => {
            const price = parseFloat(counterForm.price);
            const fractions = parseInt(counterForm.fractions);
            if (!price || !fractions) { toast.error('Enter a valid price and quantity'); return; }
            try {
              await api.respondToOffer(counterFor.id, { action: 'counter', counter_price: price, counter_fractions: fractions, message: counterForm.message });
              toast.success('Counter offer sent.');
              setCounterFor(null); fetchData();
            } catch (e) { toast.error(e.response?.data?.detail || 'Failed'); }
          }} className="w-full bg-purple-600 hover:bg-purple-700 text-white">
            Send Counter
          </Button>
        </div>
      )}
    </DialogContent>
  </Dialog>
);
